import React from 'react';
import { useSelector } from 'react-redux';
import { useField } from 'react-final-form';

import { Advice } from 'types/Checklist';
import { AbstractMedia } from 'types/AbstractMedia';
import { Extra as ExtraType } from 'types/ExtrasForm';

import { computeTax } from 'utils/priceUtils';
import useLabelTranslation from 'hooks/useLabelTranslation';

import { getCurrencyIsoCode, getValueAddedTax } from 'modules/selfServices/selectors';

import Card from 'components/ui/Card';

import AdviceCardActions from './AdviceCardActions';

interface AdviceCardProps {
  name: string;
  advices: Array<Advice>;
  mediaPlaceholder?: AbstractMedia;
}

const AdviceCard: React.FC<AdviceCardProps> = ({ name, advices, mediaPlaceholder }) => {
  const { getLabelTranslation } = useLabelTranslation();

  const vat = useSelector(getValueAddedTax);
  const currencyIsoCode = useSelector(getCurrencyIsoCode);

  const { input: { value: extra }, meta } = useField<ExtraType>(name, { subscription: { value: true, submitFailed: true, error: true } });
  const error = meta.submitFailed && meta.error?.status;

  return (
    <Card
      {...extra}
      currency={currencyIsoCode}
      mediaPlaceholder={mediaPlaceholder}
      price={computeTax(extra.price, vat)}
      discountedPrice={computeTax(extra.discountedPrice, vat)}
      title={getLabelTranslation(extra.adviceName)}
      className="h-full"
      error={error}
    >
      <AdviceCardActions name={name} advices={advices} />
    </Card>
  );
};

export default AdviceCard;
